import React, { useEffect } from 'react';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Switch, Route, Redirect, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as classnames from 'classnames';
import moment from 'moment';

import { signOut, checkedVerified } from '../../app/actions/authActions'; 
import { trigerSubscriptionPopUp  } from '../../app/actions/stripeActions'; 
import Header from '../../components/Header'
import Home from '../../components/Home';
import Footer from '../../components/Footer';
import PopUp from '../../components/PopUp';
import SearchResult from '../../components/SearchResult';
import Virus from '../Virus';
import VirusDetails from '../Virus/Details';
import Patient from '../Patient';
import PatientDocuments from '../Patient/Documents';
import Account from '../Account';
import PrivacyPolicy from '../PrivacyPolicy';
import TermsConditions from '../TermsConditions';
import Patients from '../Patients';

import './styles.scss';
import Help from "../Help";

const Dashboard = () => {
	const history = useHistory();
	const location = useLocation()
	const dispatch = useDispatch();
	const auth = useSelector((state) => state.firebase.auth);
	const uid = useSelector((state) => state.firebase.auth.uid);
	const profile = useSelector((state) => state.firebase.profile);
	const role = useSelector((state) => state.firebase.profile.role);
	const isVerified = useSelector((state) => state.auth.isVerified);
	const approved = useSelector((state) => state.auth.approved);
	const popup = useSelector((state) => state.ui.popup);
	const amountOfDaysSripe = useSelector((state) => state.stripe.amountOfDays);

	useEffect(() => {
		uid && dispatch(checkedVerified(uid));
		const isPatientUrl = location.pathname.includes('patient');
		uid && location.pathname !== '/' && !isPatientUrl && history.push(`${location.pathname}${location.search}`);

		profile.isLoaded && chackedSubscription();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]);

	const chackedSubscription = () => {
		const now = moment(new Date())
		const end = moment(Number(auth.createdAt));
		const duration = moment.duration(now.diff(end));
		
		if(duration._data.days > amountOfDaysSripe) {
			const subscription = profile.subscription.tier ? true : false;
			if(!subscription) {
				dispatch(trigerSubscriptionPopUp(true));
			};
		};
	};

	useEffect(() => {
		if(!uid ) {
			history.push('/login')
		};
	});

	if( role !== undefined && role !== 'hc-provider') { 
		dispatch(signOut());
		return <Redirect to="/info"/>;
	};

	if(!uid || !isVerified || !approved) {
		return <Redirect to="/login"/>
	};

	return (
		<div 
			className={classnames('dashboard',{
				'dashboard--active': popup.active
			})}
		>
			<Header />
			<main className="main">
				<Switch> 
					<Route exact path="/" component={Home}/>
					<Route exact path="/patients" component={Patients}/>
					<Route exact path="/privacy" component={PrivacyPolicy}/>
					<Route exact path="/help" component={Help}/>
					<Route exact path="/terms-conditions" component={TermsConditions}/>
					<Route exact path="/virus/:id" component={VirusDetails}/>
					<Route exact path="/virus/:id/add-virus/:userId?" component={Virus}/>
					<Route path="/search" component={SearchResult}/>
					<Route path="/patient/:id/virus/:idVirus" component={PatientDocuments}/>
					<Route path="/patient/:id" component={Patient}/>
					<Route path="/account" component={Account}/>
				</Switch>
			</main>
			<Footer isFixBottom/>
			<PopUp />
		</div>
	);
};
  
export default compose(
	firestoreConnect(['available_viruses'])
)(Dashboard);
